import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import { __assign, __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TariffStatement from './components/tariffStatement.vue';
import CostStatement from './components/costStatement.vue';
import TransportStatement from './components/transportStatement.vue';

var CostFlowPage = function (_super) {
  __extends(CostFlowPage, _super);

  function CostFlowPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeTab = '';
    return _this;
  }

  Object.defineProperty(CostFlowPage.prototype, "showTabList", {
    get: function get() {
      var tabList = [{
        text: this.tc('转运物流'),
        value: 'transportStatement',
        _permissionKey: 'action_transport_statement'
      }, {
        text: this.tc('关税代收代付'),
        value: 'tariffStatement',
        _permissionKey: 'action_tariff_statement'
      }];

      if (this.$util.checkContractedBusiness([this.$enum.mine.ContractTypeEnum.OVERSEA_LOCATION, this.$enum.mine.ContractTypeEnum.TRANSIT_LOCATION, this.$enum.mine.ContractTypeEnum.TARIFF])) {
        tabList.unshift({
          text: this.tc('海外仓储&中转代发'),
          value: 'costStatement'
        });
      }

      return this.$util.filterListPermission(tabList);
    },
    enumerable: false,
    configurable: true
  });

  CostFlowPage.prototype.handleChange = function (value) {
    this.activeTab = value;
    this.$router.push({
      name: 'CostFlowPage',
      query: __assign(__assign({}, this.$route.query), {
        pageType: value
      })
    });
  };

  CostFlowPage.prototype.handleSwitchTab = function (componentName) {
    this.activeTab = componentName;
  };

  CostFlowPage.prototype.created = function () {
    var pageType = this.$route.query.pageType;
    var tabList = this.showTabList.filter(function (item) {
      return item.value === pageType;
    });
    this.activeTab = tabList.length ? tabList[0].value.toString() : this.showTabList[0].value.toString();
  };

  CostFlowPage = __decorate([Component({
    components: {
      TariffStatement: TariffStatement,
      CostStatement: CostStatement,
      TransportStatement: TransportStatement
    }
  })], CostFlowPage);
  return CostFlowPage;
}(Vue);

export default CostFlowPage;